import { WritingToolsJWT } from '@src/state/auth/types'
import { getGTMData } from '@src/state/gtm/helper'
import { RootState } from '@src/state/types'
import TagManager from 'react-gtm-module'
import { createLogic } from 'redux-logic'
import { getType } from 'typesafe-actions'
import { initializeAnalytics } from '../app/actions'
import { getSiteConfig } from '../site/selectors'

export const initializeGTMLogic = createLogic<RootState, WritingToolsJWT>({
  type: getType(initializeAnalytics),
  process({ getState }, dispatch, done) {
    const { auth, preview, gtmId } = getSiteConfig(getState()).gtm
    const tagManagerArgs = {
      gtmId,
      auth,
      preview,
      dataLayer: getGTMData(getState()),
    }

    if (TagManager) {
      TagManager.initialize(tagManagerArgs)
    }
    done()
  },
})

export default [initializeGTMLogic]



// WEBPACK FOOTER //
// ./src/state/gtm/logic.ts